// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./FullQuizCreator.module.css";
// CSS
// Images
import { quiz_jame_header } from "../../../Images/images";
// Images
// Models
import { I_BudgetItem, I_FullQuizItem } from "../../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Services
import { getFullQuizDataService } from "../../../Services/Quiz/get/getFullQuizDataService";
// Services
// Components
import FullQuizCreatorCard from "./FullQuizCreatorCard/FullQuizCreatorCard";
import FullQuizCreatorModal from "./FullQuizCreatorModal/FullQuizCreatorModal";
import { getBudgetItemsService } from "../../../Services/parts/get/getBudgetItemsService";
import PendingManager from "../../../Components/PendingManager/PendingManager";
// Components

const FullQuizCreator = () => {
  const [receivedQuiz, setReceivedQuiz] = useState<I_FullQuizItem[]>([]);
  const [isModalInScreen, setIsModalInScreen] = useState<boolean>(false);
  const [modalData, setModalData] = useState<I_FullQuizItem | undefined>();
  const [isPending, setIsPending] = useState<boolean>(true);

  const [budgets, setBudgets] = useState<I_BudgetItem>();

  const userToken = useContext(UserTokenContext);

  useEffect(() => {
    getFullQuizDataService(userToken)
      .then(({ data: { data } }) => {
        setReceivedQuiz(data);
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
      });
    getBudgetItemsService(userToken)
      .then(({ data }) => {
        setBudgets(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userToken]);

  return (
    <div
      className={`${styles.fullQuizContainer} !overflow-y-hidden dark:!text-black`}
    >
      {isModalInScreen ? (
        <FullQuizCreatorModal
          setIsModalInScreen={setIsModalInScreen}
          modalData={modalData}
          setReceivedQuiz={setReceivedQuiz}
        />
      ) : null}
      <img
        src={quiz_jame_header}
        alt=""
        className="mt-5 object-contain !h-32"
      />
      <h1 className="mt-2">آزمـــون های جامـع</h1>
      <p className="text-xs text-gray-500 mt-1">
        دسترسی به آزمون های آماده و معتبر
      </p>

      {isPending === false && receivedQuiz.length === 0 ? (
        <h1 className="mt-8 text-xl">برای مقطع شما آزمونی وجود ندارد</h1>
      ) : (
        <></>
      )}

      <PendingManager
        isPending={isPending}
        data={
          <>
            {budgets ? (
              <a
                href={budgets?.file.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                className="py-2 px-6 my-6 text-white rounded-lg"
                rel="noreferrer"
                target="_blank"
                style={{ backgroundColor: "rgb(0 , 150 ,136)" }}
              >
                دانلود فایل بودجه بندی آزمون
              </a>
            ) : null}
            <div className="mt-2 w-full px-2 box-border overflow-y-auto h-max">
              {receivedQuiz.map((item) => (
                <FullQuizCreatorCard
                  data={item}
                  key={item.id}
                  setIsModalInScreen={setIsModalInScreen}
                  setModalData={setModalData}
                />
              ))}
            </div>
          </>
        }
      />
    </div>
  );
};

export default FullQuizCreator;
